import React, { Component } from 'react'
import { Input } from '@driftt/tide-core'
import hidePasswordIcon from './hidePassword.svg'
import showPasswordIcon from './showPassword.svg'
import regenerateIcon from './regenerate.svg'
import { getAppAuthorization, refreshClientSecret, refreshVerificationToken } from 'api/developerApi'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import cx from 'classnames'
import 'styles/input.css'
import './style.css'

class AppCredentials extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isPasswordVisible: false,
    isFetchingCredentials: false,
    isRefreshingSecret: false,
    isRefreshingVerification: false
  }

  componentDidMount = () => {
    this.fetchCredentials()
  }

  secretIdInputType = () => {
    const { isPasswordVisible } = this.state
    return isPasswordVisible ? 'text' : 'password'
  }

  passwordIconSrc = () => {
    const { isPasswordVisible } = this.state
    return isPasswordVisible ? hidePasswordIcon : showPasswordIcon
  }

  toggleSecretIdVisibility = () => {
    const { isPasswordVisible } = this.state
    this.setState({ isPasswordVisible: !isPasswordVisible });
  }

  fetchCredentials = () => {
    const onDone = ({ clientId, clientSecret, verificationToken }) => {
      this.setState({ clientId, clientSecret, verificationToken })
    }

    const onError = (error) => {
      this.props.showErrorNotification('Ooops, something went wrong. Please refresh the page.')
    }

    const onFinally = () => {
      this.setState({ isFetchingCredentials: false })
    }

    const onStateSet = () => {
      getAppAuthorization(this.props.appId)
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ isFetchingCredentials: true }, onStateSet)
  }

  onRefreshSecret = (refresher, type) => {
    const onDone = ({ clientId, clientSecret, verificationToken }) => {
      this.setState({ clientId, clientSecret, verificationToken })
    }

    const onError = (error) => {
      this.props.showErrorNotification('We couldn’t refresh the secret ID. Please try again.')
    }

    const onFinally = () => {
      this.setState({ [type]: false })
    }

    const onStateSet = () => {
      refresher(this.props.appId)
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ [type]: true }, onStateSet)
  }

  render() {
    const {
      clientId,
      clientSecret,
      verificationToken,
      isFetchingCredentials,
      isRefreshingSecret,
      isRefreshingVerification
    } = this.state

    const inputClasses = cx('app-credentials-input', {
      'drift-input-loading': isFetchingCredentials,
      'drift-input-loaded': !isFetchingCredentials
    })

    return (
      <div className="app-credentials">
        <span className="page-title">
          App Credentials
        </span>
        <p className="page-description">
          These credentials allow your app to access the Drift API. They are secret.
          Please don’t share your app credentials with anyone, include them in public code repositories,
          or store them in insecure ways.
        </p>

        <div className="app-credentials-inputs">
          <Input
            label="Client ID"
            labelType="strong"
            className={inputClasses}
            value={clientId}
            readOnly
          />

          <div className="app-secret-id-wrapper">
            <Input
              label="Secret ID"
              labelType="strong"
              description="You’ll need to send this secret along with your client ID when making your request."
              type={this.secretIdInputType()}
              className={inputClasses}
              value={clientSecret}
              readOnly
            />
            <img
              className="app-secret-id-show-hide"
              src={this.passwordIconSrc()}
              alt="password visibility toggle"
              onClick={this.toggleSecretIdVisibility}
            />
            <button
              className={cx('app-credentials-regenerate', {
                'app-credentials-regenerating': isRefreshingSecret
              })}
              onClick={() => this.onRefreshSecret(refreshClientSecret, 'isRefreshingSecret')}>
              <img src={regenerateIcon} alt="regenerate" />
              <span>Regenerate</span>
            </button>
          </div>

          <div className="app-verification-token-wrapper">
            <Input
              label="Verification Token"
              labelType="strong"
              size="medium"
              description="For interactive messages and events, use this token to verify that requests are actually coming from Drift."
              className={inputClasses}
              value={verificationToken}
              readOnly
            />
              <button
                className={cx('app-credentials-regenerate', {
                  'app-credentials-regenerating': isRefreshingVerification
                })}
                onClick={() => this.onRefreshSecret(refreshVerificationToken, 'isRefreshingVerification')}>
                <img src={regenerateIcon} alt="regenerate" />
                <span>Regenerate</span>
              </button>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(AppCredentials)
